var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-wrapper"},[_c('h1',{staticClass:"u-layout__space--top-double u-layout__space--bottom-double u-title u-font__align--center u-font__family--anton u-font__transform--upper u-font__size--xxxlarge"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }